export const FIELDS_ARRAY = [
  { key: "title", fieldName: "Title" },
  { key: "category", fieldName: "Category" },
  { key: "addedBy", fieldName: "Created By" },
];

export const FOOTER = "Enter a comma (,) after each tag";

export const TAGS_PLACEHOLDER = "Product ID";
